import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    tipAttached: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].tipAttached,
    plungerPosition: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].plungerPosition,
    animatingOut: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].animatingOut,
    currentPlungerPos: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].currentPlungerPos,
    solution: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].solution,
    type: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].type,
    maxVol: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].maxVol,
    volume: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].volume
  }
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
